<template>
  <div class="insights-percentage-chip">
    <v-chip x-small class="pa-0 ma-0 me-2" :color="percentageChangeColor">
      <div class="d-flex align-center justify-center mx-1 px-1">
        <v-icon
          v-if="percentageChange !== 0"
          size="12"
          :color="percentageChange > 0 ? 'green darken-1' : 'red darken-1'"
        >
          {{
            percentageChange > 0 ? 'mdi-arrow-up-thin' : 'mdi-arrow-down-thin'
          }}
        </v-icon>
        <p
          class="ma-0 pa-0 font-size-10 font-weight-400 text--darken-1"
          style="line-height: 8px; letter-spacing: 0.4px;"
          :class="percentageTextColor"
        >
          {{ percentageChangeText }}
        </p>
      </div>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'PercentageChangeChip',

  props: {
    percentageChange: Number,
  },

  computed: {
    percentageChangeColor() {
      if (this.percentageChange === 0) return 'blue-grey lighten-3'
      return this.percentageChange > 0 ? 'green lighten-2' : 'red lighten-2'
    },

    percentageTextColor() {
      if (this.percentageChange === 0) return 'blue-grey--text'

      return this.percentageChange > 0 ? 'green--text' : 'red--text'
    },

    percentageChangeText() {
      if (this.percentageChange === 0) return '0%'

      const percentage =
        this.percentageChange > 0
          ? this.percentageChange
          : this.percentageChange * -1

      return `${percentage}%`
    },
  },
}
</script>

<style lang="scss">
.insights-percentage-chip {
  .v-chip:hover::before {
    opacity: 0 !important;
  }
}
</style>
